import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getPharmacySettingsRepository } from '../../../domains/pharmacySettings';

const KEY = ['pharmacy-settings'];

const unwrap = (res: any) => {
  if (res?.result_code !== '200') throw new Error(res?.result_msg || '요청에 실패했습니다.');
  return res.data;
};

/** GET /pharmacy/settings → { pharmacy_info, social_links } */
export const usePharmacySettings = () =>
  useQuery({
    queryKey: KEY,
    queryFn: async () => unwrap(await getPharmacySettingsRepository().getSettings()),
  });

/** PUT /pharmacy/settings — 응답이 저장 후 전체 설정이라 캐시에 그대로 반영 */
export const useUpdatePharmacySettings = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: Record<string, any>) => unwrap(await getPharmacySettingsRepository().updateSettings(body)),
    onSuccess: (data) => qc.setQueryData(KEY, data),
  });
};
